import React, { useState, useEffect } from "react";
import Logo from "./Logo";
import LanguageMenu from "./LanguageMenu";
import BackButton from "./BackButton";
import Authentication from "../Authentication/Authentication";
import { useTranslation } from "react-i18next";

import { getContentById } from "../../../hooks/useContent";
import useAnalyticsEventTracker from "../../../hooks/useAnalyticsEventTracker";
import styled from "@emotion/styled";
import { useEbbnenContext } from "@solidwhite/ebbnen";
import { config, useSpring, animated as a } from "@react-spring/web";
import { useMultiuserContext } from "@solidwhite/multiuser";
import { Autoplay } from "../../Autoplay.tsx";
import { useSnapshot } from "valtio";
import store from "../../../appStore.js";

const HeaderBar = () => {
  const { currentId, currentLayer, locationHook } = useEbbnenContext();
  const { spectating } = useMultiuserContext();
  const [location, setLocation] = locationHook();
  const { t } = useTranslation();
  const gaEventTracker = useAnalyticsEventTracker("Header Bar");
  const [heading, setHeading] = useState(null);
  const { autoPlayTimeline } = useSnapshot(store);

  useEffect(() => {
    getContentById(currentId).then((data) => {
      data ? setHeading(data.sloganTranslationKey) : setHeading(null);
    });
  }, [currentId]);

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: "1.5vw",
        width: "70%",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        paddingLeft: "2vw",
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "flex-start",
          marginBottom: "1.5vh",
        }}
      >
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            setLocation("/");
            gaEventTracker("logo click");
          }}
        >
          <Logo logoWhite />
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
            paddingLeft: "1.5vw",
          }}
        >
          <ul
            style={{
              display: "flex",
              listStyle: "none",
              color: "#fff",
              margin: 0,
              padding: 0,
              width: "max-content",
            }}
          >
            {!spectating && import.meta.env.MODE !== "electron" && (
              <ListElement eventTracker={() => gaEventTracker("login click")}>
                <Authentication />
              </ListElement>
            )}

            {import.meta.env.MODE === "electron" && autoPlayTimeline && (
              <ListElement>
                <span
                  style={{
                    position: "relative",
                    zIndex: 9999999,
                    color: "#fff",
                    textDecoration: "none",
                    pointerEvents: "auto",
                    cursor: "pointer",
                    fontSize: "0.8vw",
                  }}
                >
                  <Autoplay />
                </span>
              </ListElement>
            )}

            {import.meta.env.MODE !== "electron" && (
              <ListElement
                eventTracker={() => gaEventTracker("contact button click")}
                style={{
                  position: "relative",
                  zIndex: 9999999,
                }}
              >
                <a
                  style={{
                    position: "relative",
                    zIndex: 9999999,
                    color: "#fff",
                    textDecoration: "none",
                    pointerEvents: "auto",
                    fontSize: "0.8vw",
                  }}
                  href={t("BUTTON_GET_IN_TOUCH_URL")}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("BUTTON_CONTACT")}
                </a>
              </ListElement>
            )}

            <ListElement>
              <LanguageMenu />
            </ListElement>
          </ul>
          {heading && <Heading textId={heading} key={`heading_${heading}`} />}
        </div>
      </div>
      <BackButton />
    </div>
  );
};

export default HeaderBar;

const ListElement = ({ children, eventTracker }) => {
  const ListEl = styled.li`
    &:after {
      width: 2px;
      height: 1vw;
      margin: 0 0.8vw;
      content: "";
      background-color: white;
    }
    &:nth-last-of-type(1) {
      &:after {
        width: 0px;
        height: 0px;
      }
    }
  `;

  return (
    <ListEl
      style={{
        display: "flex",
        alignItems: "flex-start",
      }}
      onClick={eventTracker ? eventTracker : null}
    >
      {children}
    </ListEl>
  );
};

const Heading = ({ textId = "" }) => {
  const { t } = useTranslation();

  const spring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: config.molasses,
    delay: 200,
  });

  return (
    <a.div style={{ ...spring }}>
      <h2
        style={{
          color: "#fff",
          fontSize: "3.2vw",
          margin: 0,
          fontWeight: "100",
          position: "absolute",
          top: "4vh",
        }}
      >
        {t(textId)}
      </h2>
    </a.div>
  );
};
